(() => {
  const root = document.documentElement;
  const body = document.body;
  body.classList.add('reveal-ready');
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  const routes = window.RecoverHER?.routes || {};

  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
  const stripMoneyMarkup = (value) => String(value).replace(/<[^>]*>/g, '');
  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const format = window.RecoverHER?.moneyFormat || '${{amount}}';
    return stripMoneyMarkup(format
      .replace('{{amount}}', amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount_no_decimals}}', Math.round(Number(cents || 0) / 100).toLocaleString())
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(Number(cents || 0) / 100).toLocaleString('de-DE')));
  };

  let toastTimer;
  const toast = (message) => {
    const element = $('[data-cart-toast]');
    if (!element) return;
    element.textContent = message;
    element.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => element.classList.remove('is-visible'), 2800);
  };

  const setBodyLocked = () => {
    const hasOverlay = $('.mobile-menu.is-open, .search-overlay.is-open, .cart-drawer.is-open, .filter-drawer.is-open');
    body.classList.toggle('no-scroll', Boolean(hasOverlay));
  };

  const setExpanded = (element, expanded) => element?.setAttribute('aria-expanded', String(expanded));
  const setHidden = (element, hidden) => element?.setAttribute('aria-hidden', String(hidden));

  const toggleMenu = (open) => {
    const menu = $('[data-mobile-menu]');
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    setHidden(menu, !open);
    setExpanded($('[data-menu-toggle]'), open);
    setBodyLocked();
  };
  const toggleSearch = (open) => {
    const overlay = $('[data-search-overlay]');
    if (!overlay) return;
    overlay.classList.toggle('is-open', open);
    setHidden(overlay, !open);
    setExpanded($('[data-search-toggle]'), open);
    setBodyLocked();
    if (open) setTimeout(() => $('#HeaderSearch')?.focus(), 120);
  };
  const toggleFilters = (open) => {
    const drawer = $('[data-filter-drawer]');
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    body.classList.toggle('cart-open', open);
    setHidden(drawer, !open);
    setBodyLocked();
  };
  const toggleCart = (open) => {
    const drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    body.classList.toggle('cart-open', open);
    setHidden(drawer, !open);
    setBodyLocked();
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.matches('[data-menu-toggle]')) toggleMenu(true);
    if (target.matches('[data-menu-close]')) toggleMenu(false);
    if (target.matches('[data-search-toggle]')) toggleSearch(true);
    if (target.matches('[data-search-close]')) toggleSearch(false);
    if (target.matches('[data-filter-open]')) toggleFilters(true);
    if (target.matches('[data-filter-close]')) toggleFilters(false);
    if (target.matches('[data-cart-close]')) toggleCart(false);
    if (target.matches('[data-cart-open]') && window.RecoverHER?.cartType === 'drawer') {
      event.preventDefault();
      toggleCart(true);
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    toggleMenu(false); toggleSearch(false); toggleFilters(false); toggleCart(false);
  });

  const initReveal = (context = document) => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      $$('[data-reveal]', context).forEach((element) => element.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    }, { threshold: .1, rootMargin: '0px 0px -30px' });
    $$('[data-reveal]', context).forEach((element) => observer.observe(element));
  };

  let scrollFrame = 0;
  const renderScrollScenes = () => {
    scrollFrame = 0;
    const pageTravel = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    root.style.setProperty('--page-p', (window.scrollY / pageTravel).toFixed(4));
    $$('[data-hero]').forEach((hero) => {
      const rect = hero.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      hero.style.setProperty('--hero-p', progress.toFixed(3));
    });
    $$('[data-stack]').forEach((stack) => {
      const rect = stack.getBoundingClientRect();
      const travel = Math.max(rect.height - window.innerHeight, 1);
      const progress = Math.max(0, Math.min(1, -rect.top / travel));
      stack.style.setProperty('--stack-p', progress.toFixed(3));
      const phase = Math.min(3, Math.floor(progress * 3) + 1);
      stack.dataset.phase = String(phase);
      $$('[data-stack-copy]', stack).forEach((copy) => copy.classList.toggle('is-active', Number(copy.dataset.stackCopy) === phase));
    });
  };
  const requestScrollRender = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(renderScrollScenes); };
  window.addEventListener('scroll', requestScrollRender, { passive: true });
  window.addEventListener('resize', requestScrollRender);
  window.addEventListener('pointermove', (event) => {
    const hero = $('[data-hero]');
    if (!hero || hero.getBoundingClientRect().bottom < 0) return;
    hero.style.setProperty('--mx', (((event.clientX / window.innerWidth) - .5) * 2).toFixed(3));
    hero.style.setProperty('--my', (((event.clientY / window.innerHeight) - .5) * 2).toFixed(3));
  }, { passive: true });

  const cartLineHTML = (item) => {
    const image = item.featured_image?.url || item.image || '';
    const resizedImage = image ? `${image}${image.includes('?') ? '&' : '?'}width=260` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHTML(item.variant_title)}</p>` : '';
    const vendor = item.vendor ? `<small>${escapeHTML(item.vendor)}</small>` : '';
    return `<article class="drawer-item" data-cart-line="${escapeHTML(item.key)}">
      <a href="${escapeHTML(item.url)}" class="drawer-item-image">${resizedImage ? `<img src="${escapeHTML(resizedImage)}" width="260" height="260" loading="lazy" alt="${escapeHTML(item.product_title)}">` : ''}</a>
      <div>${vendor}<a href="${escapeHTML(item.url)}"><h3>${escapeHTML(item.product_title)}</h3></a>${variant}<strong>${formatMoney(item.final_line_price)}</strong>
        <div class="drawer-qty"><button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button><input type="number" value="${item.quantity}" min="0" data-line-quantity aria-label="Quantity"><button type="button" data-qty-change="1" aria-label="Increase quantity">+</button><button class="drawer-remove" type="button" data-remove-line>REMOVE</button></div>
      </div></article>`;
  };

  const updateShippingProgress = (cart) => {
    const threshold = Number(window.RecoverHER?.freeShippingThreshold || 0);
    const copy = $('[data-shipping-copy]');
    const progress = $('[data-shipping-progress]');
    if (!threshold || !copy) return;
    const remaining = Math.max(0, threshold - Number(cart.total_price || 0));
    copy.textContent = remaining > 0 ? `You’re ${formatMoney(remaining)} away from free shipping` : 'Free shipping unlocked';
    if (progress) progress.style.width = `${Math.min(100, (Number(cart.total_price || 0) / threshold) * 100)}%`;
  };

  const renderCart = (cart) => {
    updateShippingProgress(cart);
    $$('[data-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
    $$('[data-cart-drawer-count]').forEach((element) => { element.textContent = `(${cart.item_count})`; });
    const items = $('[data-cart-items]');
    const footer = $('[data-cart-footer]');
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = `<div class="drawer-empty"><span>HER</span><h3>Your ritual starts here.</h3><p>Add something beautiful to your daily routine.</p><a class="rh-button rh-button--dark" href="${escapeHTML(routes.allProducts || '/collections/all')}">SHOP ALL PRODUCTS ↗</a></div>`;
      if (footer) footer.hidden = true;
    } else {
      items.innerHTML = cart.items.map(cartLineHTML).join('');
      if (footer) footer.hidden = false;
      const total = $('[data-cart-total]', footer || document);
      if (total) total.textContent = formatMoney(cart.total_price);
    }
  };
  const getCart = async () => {
    const response = await fetch(`${routes.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load bag.');
    const cart = await response.json(); renderCart(cart); return cart;
  };
  const changeCartLine = async (key, quantity) => {
    const response = await fetch(routes.cartChange || '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (!response.ok) throw new Error('Unable to update bag.');
    const cart = await response.json(); renderCart(cart); return cart;
  };

  document.addEventListener('click', async (event) => {
    const quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault();
      const original = quickAdd.textContent;
      quickAdd.disabled = true; quickAdd.textContent = 'ADDING…';
      try {
        const response = await fetch(routes.cartAdd || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(quickAdd.dataset.variantId), quantity: 1 }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add product.');
        await getCart(); toast('ADDED TO YOUR BAG ✓');
        if (window.RecoverHER?.cartType === 'drawer') toggleCart(true);
      } catch (error) { toast(error.message); }
      finally { quickAdd.disabled = false; quickAdd.textContent = original; }
      return;
    }

    const quantityButton = event.target.closest('[data-qty-change], [data-remove-line]');
    if (quantityButton) {
      const line = quantityButton.closest('[data-cart-line]');
      const input = $('[data-line-quantity]', line);
      if (!line || !input) return;
      const quantity = quantityButton.matches('[data-remove-line]') ? 0 : Math.max(0, Number(input.value || 0) + Number(quantityButton.dataset.qtyChange || 0));
      quantityButton.disabled = true;
      try { await changeCartLine(line.dataset.cartLine, quantity); }
      catch (error) { toast(error.message); quantityButton.disabled = false; }
      return;
    }

    const productQty = event.target.closest('[data-product-qty]');
    if (productQty) {
      const input = $('[data-product-quantity]', productQty.closest('.product-form'));
      if (input) input.value = Math.max(1, Number(input.value || 1) + Number(productQty.dataset.productQty));
    }

    const pageQty = event.target.closest('[data-cart-page-qty]');
    if (pageQty) {
      const input = $('input', pageQty.parentElement);
      if (input) input.value = Math.max(0, Number(input.value || 0) + Number(pageQty.dataset.cartPageQty));
    }

    const thumb = event.target.closest('[data-media-target]');
    if (thumb) {
      const gallery = thumb.closest('[data-product-gallery]');
      $$('[data-media-target]', gallery).forEach((button) => {
        const active = button === thumb;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      $$('[data-media-id]', gallery).forEach((media) => {
        const active = media.dataset.mediaId === thumb.dataset.mediaTarget;
        media.classList.toggle('is-active', active);
        media.setAttribute('aria-hidden', String(!active));
      });
    }

    const showRecover = event.target.closest('[data-show-recover]');
    if (showRecover) { $('#CustomerLogin').hidden = true; $('#RecoverPassword').hidden = false; }
    const hideRecover = event.target.closest('[data-hide-recover]');
    if (hideRecover) { $('#CustomerLogin').hidden = false; $('#RecoverPassword').hidden = true; }
    const deleteAddress = event.target.closest('[data-address-delete]');
    if (deleteAddress && deleteAddress.dataset.addressUrl && confirm(deleteAddress.dataset.confirmMessage || 'Delete this address?')) {
      const form = document.createElement('form'); form.method = 'post'; form.action = deleteAddress.dataset.addressUrl;
      const method = document.createElement('input'); method.type = 'hidden'; method.name = '_method'; method.value = 'delete'; form.append(method); document.body.append(form); form.submit();
    }
  });

  $$('[data-product-form]').forEach((form) => {
    if (window.RecoverHER?.cartType !== 'drawer') return;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = $('[data-product-submit]', form);
      if (!submit || submit.disabled) return;
      const section = form.closest('[data-product-section]');
      const stickySubmit = $('[data-sticky-submit]', section || document);
      const stickyText = $('[data-sticky-submit-text]', section || document);
      const original = $('[data-submit-text]', submit)?.textContent || submit.textContent;
      const stickyOriginal = stickyText?.textContent || '';
      submit.disabled = true;
      if (stickySubmit) stickySubmit.disabled = true;
      if ($('[data-submit-text]', submit)) $('[data-submit-text]', submit).textContent = 'ADDING TO BAG…';
      if (stickyText) stickyText.textContent = 'ADDING…';
      try {
        const response = await fetch(routes.cartAdd || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add product.');
        await getCart(); toggleCart(true); toast('ADDED TO YOUR BAG ✓');
      } catch (error) { toast(error.message); }
      finally {
        submit.disabled = false;
        if (stickySubmit) stickySubmit.disabled = false;
        if ($('[data-submit-text]', submit)) $('[data-submit-text]', submit).textContent = original;
        if (stickyText) stickyText.textContent = stickyOriginal;
      }
    });
  });

  $$('[data-product-section]').forEach((section) => {
    const json = $('[data-product-json]', section);
    if (!json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch { return; }
    const updateVariant = () => {
      const options = $$('[data-option-group]', section).map((group) => $('[data-option-value]:checked', group)?.value);
      const variant = variants.find((candidate) => candidate.options.every((value, index) => value === options[index])) || (variants.length === 1 ? variants[0] : null);
      const idInput = $('[data-variant-id]', section);
      const submit = $('[data-product-submit]', section);
      const submitText = $('[data-submit-text]', section);
      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'UNAVAILABLE';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (submit) submit.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? `ADD TO BAG — ${formatMoney(variant.price)}` : 'SOLD OUT';
      const stickySubmit = $('[data-sticky-submit]', section);
      const stickySubmitText = $('[data-sticky-submit-text]', section);
      const stickyPrice = $('[data-sticky-price]', section);
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      if (stickySubmitText) stickySubmitText.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      const price = $('[data-price]', section);
      if (price) price.innerHTML = `<span class="price-current">${formatMoney(variant.price)}</span>${variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}`;
      if (variant.featured_media?.id) $('[data-media-target="' + variant.featured_media.id + '"]', section)?.click();
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      $$('[data-option-group]', section).forEach((group) => { const selected = $('[data-option-value]:checked', group); const label = $('[data-selected-option]', group); if (label && selected) label.textContent = selected.value; });
    };
    section.addEventListener('change', (event) => { if (event.target.matches('[data-option-value]')) updateVariant(); });
  });

  const initStickyAdd = (context = document) => {
    $$('[data-product-section]', context).forEach((section) => {
      const sticky = $('[data-sticky-atc]', section);
      const purchaseRow = $('[data-primary-purchase-row]', section);
      const form = $('[data-product-form]', section);
      const stickySubmit = $('[data-sticky-submit]', section);
      const mainSubmit = $('[data-product-submit]', section);
      if (!sticky || !purchaseRow || !form || !stickySubmit || sticky.dataset.initialized === 'true') return;
      sticky.dataset.initialized = 'true';
      let purchaseVisible = true;
      const setStickyState = () => {
        const visible = !purchaseVisible && window.scrollY > 80;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        stickySubmit.tabIndex = visible ? 0 : -1;
        body.classList.toggle('has-pdp-sticky', visible);
      };
      const observer = new IntersectionObserver((entries) => {
        purchaseVisible = entries[0]?.isIntersecting ?? true;
        setStickyState();
      }, { threshold: .15, rootMargin: '-90px 0px -20px 0px' });
      observer.observe(purchaseRow);
      window.addEventListener('scroll', setStickyState, { passive: true });
      stickySubmit.addEventListener('click', () => {
        if (mainSubmit?.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(mainSubmit);
        else mainSubmit?.click();
      });
      setStickyState();
    });
  };

  document.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-line-quantity]');
    if (!input) return;
    const line = input.closest('[data-cart-line]');
    if (!line) return;
    try { await changeCartLine(line.dataset.cartLine, Math.max(0, Number(input.value || 0))); }
    catch (error) { toast(error.message); }
  });

  $('[data-sort-select]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href); url.searchParams.set('sort_by', event.target.value); window.location.assign(url.toString());
  });

  document.addEventListener('shopify:section:load', (event) => { initReveal(event.target); initStickyAdd(event.target); renderScrollScenes(); });
  initReveal(); initStickyAdd(); renderScrollScenes();
})();
